import getMessage from 'src/background/utils/i18n.utils';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
const ImportKeys = ({}) => {
    return (React.createElement("div", { className: "import-keys-page", "data-testid": `${Screen.ACCOUNT_PAGE_IMPORT_KEYS}-page` }, getMessage('popup_html_import_keys')));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const ImportKeysComponent = connector(ImportKeys);
